// import React, { useRef, useEffect } from "react";
// import { Modal, Button } from "react-bootstrap";

// const CameraCapture = ({ show, onClose, onCapture, title, documentType }) => {
//     const videoRef = useRef(null);
//     const canvasRef = useRef(null);

//     useEffect(() => {
//         if (show) {
//         const constraints = {
//             video: {
//                 width: 1000,
//                 height: 800,
//                 facingMode: documentType === "selfie" ? "user" : { exact: "environment" },
//             },
//         };

//         navigator.mediaDevices
//             .getUserMedia(constraints)
//             .then((stream) => {
//             if (videoRef.current) {
//                 videoRef.current.srcObject = stream;
//             }
//             })
//             .catch((err) => {
//             console.error("No se pudo abrir la cámara:", err);
//             });
//         }

//         return () => {
//             if (videoRef.current && videoRef.current.srcObject) {
//                 videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
//             }
//         };
//     }, [show, documentType]);

//     const handleCapture = () => {
//         const video = videoRef.current;
//         const canvas = canvasRef.current;

//         if (video && canvas) {
//         const context = canvas.getContext("2d");
//         canvas.width = video.videoWidth;
//         canvas.height = video.videoHeight;
//         context.drawImage(video, 0, 0, canvas.width, canvas.height);
//         const imageData = canvas.toDataURL("image/png");
//         onCapture(imageData);
//         onClose();
//         }
//     };

//     return (
//         <Modal show={show} onHide={onClose} size="lg" centered>
//         <Modal.Header closeButton>
//             <Modal.Title>{title}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body className="text-center position-relative">
//             <video
//                 ref={videoRef}
//                 autoPlay
//                 playsInline
//                 className="w-100 rounded"
//                 style={{ maxHeight: "70vh" }}
//             />
//             <canvas ref={canvasRef} style={{ display: "none" }} />

//             {/* Solo mostramos overlay si es documento */}
//             {documentType !== "selfie" && (
//             <div
//                 style={{
//                     position: "absolute",
//                     top: "50%",
//                     left: "50%",
//                     width: "320px",
//                     height: "220px",
//                     border: "4px solid #00ff00",
//                     borderRadius: "12px",
//                     transform: "translate(-50%, -50%)",
//                     pointerEvents: "none",
//                 }}
//             />
//             )}
//         </Modal.Body>
//         <Modal.Footer>
//             <Button variant="secondary" onClick={onClose}>
//                 Cancelar
//             </Button>
//             <Button variant="primary" onClick={handleCapture}>
//                 Capturar
//             </Button>
//         </Modal.Footer>
//         </Modal>
//     );
// };

// export default CameraCapture;


// import React, { useRef, useEffect } from "react";
// import { Modal, Button } from "react-bootstrap";
// import "../styles/CameraCapture.css"; // importamos estilos

// const CameraCapture = ({ show, onClose, onCapture, title, documentType }) => {
//   const videoRef = useRef(null);
//   const canvasRef = useRef(null);

//   // Dimensiones de la guía (puedes ajustarlas según necesites)
//   const GUIDE_WIDTH = 320;
//   const GUIDE_HEIGHT = 220;

//   useEffect(() => {
//     if (show) {
//       const constraints = {
//         video: {
//           width: 1000,
//           height: 800,
//           facingMode:
//             documentType === "selfie" ? "user" : { exact: "environment" },
//         },
//       };

//       navigator.mediaDevices
//         .getUserMedia(constraints)
//         .then((stream) => {
//           if (videoRef.current) {
//             videoRef.current.srcObject = stream;
//           }
//         })
//         .catch((err) => {
//           console.error("No se pudo abrir la cámara:", err);
//         });
//     }

//     return () => {
//       if (videoRef.current && videoRef.current.srcObject) {
//         videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
//       }
//     };
//   }, [show, documentType]);

//   const handleCapture = () => {
//     const video = videoRef.current;
//     const canvas = canvasRef.current;

//     if (video && canvas) {
//       const context = canvas.getContext("2d");
//       canvas.width = video.videoWidth;
//       canvas.height = video.videoHeight;

//       // Dibujar el frame completo
//       context.drawImage(video, 0, 0, canvas.width, canvas.height);

//       // --- Calcular posición real de la guía ---
//       const videoRect = video.getBoundingClientRect();

//       const guideWidth = GUIDE_WIDTH;
//       const guideHeight = GUIDE_HEIGHT;
//       const guideX = (videoRect.width - guideWidth) / 2;
//       const guideY = (videoRect.height - guideHeight) / 2;

//       // Escalas pantalla → canvas
//       const scaleX = canvas.width / videoRect.width;
//       const scaleY = canvas.height / videoRect.height;

//       const cropX = guideX * scaleX;
//       const cropY = guideY * scaleY;
//       const cropW = guideWidth * scaleX;
//       const cropH = guideHeight * scaleY;

//       // --- Recortar ---
//       const croppedCanvas = document.createElement("canvas");
//       croppedCanvas.width = cropW;
//       croppedCanvas.height = cropH;
//       const croppedCtx = croppedCanvas.getContext("2d");

//       croppedCtx.drawImage(
//         canvas,
//         cropX,
//         cropY,
//         cropW,
//         cropH,
//         0,
//         0,
//         cropW,
//         cropH
//       );

//       const imageData = croppedCanvas.toDataURL("image/png");
//       onCapture(imageData);
//       onClose();
//     }
//   };

//   return (
//     <Modal show={show} onHide={onClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>{title}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body className="text-center position-relative">
//         <video
//           ref={videoRef}
//           autoPlay
//           playsInline
//           className="w-100 rounded"
//           style={{ maxHeight: "70vh" }}
//         />
//         <canvas ref={canvasRef} style={{ display: "none" }} />

//         {/* Overlay con guía (solo documentos, no para selfie) */}
//         {documentType !== "selfie" && (
//           <div
//             className="camera-overlay"
//             style={{
//               width: `${GUIDE_WIDTH}px`,
//               height: `${GUIDE_HEIGHT}px`,
//             }}
//           />
//         )}
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onClose}>
//           Cancelar
//         </Button>
//         <Button variant="primary" onClick={handleCapture}>
//           Capturar
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );

// };

// export default CameraCapture;


import React, { useRef, useEffect, useState } from "react";
import { Modal, Button, Alert } from "react-bootstrap";
import * as bodyPix from "@tensorflow-models/body-pix";
import "@tensorflow/tfjs";
import "../styles/CameraCapture.css";

const CameraCapture = ({ show, onClose, onCapture, title, documentType }) => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const modelRef = useRef(null);
  const [cameraError, setCameraError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const GUIDE_WIDTH = 320;
  const GUIDE_HEIGHT = 220;

  useEffect(() => {
    if (show) {
      setCameraError(null);
      setIsLoading(true);

      const constraints = {
        video: {
          width: 1000,
          height: 800,
          facingMode:
            documentType === "selfie" ? "user" : { exact: "environment" },
        },
      };

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
            setIsLoading(false);
          }
        })
        .catch((err) => {
          console.error("No se pudo abrir la cámara:", err);
          
          let errorMessage = "No se pudo acceder a la cámara.";
          
          if (err.name === "NotFoundError" || err.name === "DevicesNotFoundError") {
            errorMessage = "❌ No se detectó ninguna cámara conectada. Por favor, conecta una cámara e intenta nuevamente.";
          } else if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
            errorMessage = "❌ Permiso denegado. Por favor, permite el acceso a la cámara en la configuración del navegador.";
          } else if (err.name === "NotReadableError") {
            errorMessage = "❌ La cámara está siendo usada por otra aplicación.";
          }
          
          setCameraError(errorMessage);
          setIsLoading(false);
        });

      if (documentType === "selfie") {
        bodyPix
          .load({
            architecture: "MobileNetV1",
            outputStride: 16,
            multiplier: 0.75,
            quantBytes: 2,
          })
          .then((net) => {
            modelRef.current = net;
            console.log("✅ Modelo BodyPix cargado");
          })
          .catch((err) => console.error("Error cargando BodyPix:", err));
      }
    }

    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        videoRef.current.srcObject.getTracks().forEach((track) => track.stop());
      }
    };
  }, [show, documentType]);

  const handleCapture = async () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;

    if (!video || !canvas) {
      alert("❌ Error: No se pudo acceder al video o canvas");
      return;
    }

    // Validar que el video tenga dimensiones válidas
    if (video.videoWidth === 0 || video.videoHeight === 0) {
      alert("❌ Error: La cámara no está transmitiendo correctamente. Por favor, verifica que esté conectada.");
      return;
    }

    const context = canvas.getContext("2d");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // 👉 Selfie con fondo celeste
    if (documentType === "selfie" && modelRef.current) {
      const segmentation = await modelRef.current.segmentPerson(video, {
        internalResolution: "medium",
        segmentationThreshold: 0.7,
      });

      const { width, height, data: mask } = segmentation;

      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
      const pixels = imageData.data;

      for (let i = 0; i < mask.length; i++) {
        if (mask[i] === 0) {
          pixels[i * 4] = 135;     // R
          pixels[i * 4 + 1] = 206; // G
          pixels[i * 4 + 2] = 235; // B
          pixels[i * 4 + 3] = 255; // A
        }
      }

      context.putImageData(imageData, 0, 0);

      const finalImage = canvas.toDataURL("image/png");
      onCapture(finalImage);
      onClose();
      return;
    }

    // 👉 Documentos con recorte rectangular
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    const videoRect = video.getBoundingClientRect();
    const guideX = (videoRect.width - GUIDE_WIDTH) / 2;
    const guideY = (videoRect.height - GUIDE_HEIGHT) / 2;

    const scaleX = canvas.width / videoRect.width;
    const scaleY = canvas.height / videoRect.height;

    const cropX = guideX * scaleX;
    const cropY = guideY * scaleY;
    const cropW = GUIDE_WIDTH * scaleX;
    const cropH = GUIDE_HEIGHT * scaleY;

    const croppedCanvas = document.createElement("canvas");
    croppedCanvas.width = cropW;
    croppedCanvas.height = cropH;
    const croppedCtx = croppedCanvas.getContext("2d");

    croppedCtx.drawImage(canvas, cropX, cropY, cropW, cropH, 0, 0, cropW, cropH);

    const imageData = croppedCanvas.toDataURL("image/png");
    onCapture(imageData);
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center position-relative">
        {cameraError ? (
          <Alert variant="danger" className="m-3">
            {cameraError}
            <hr />
            <p className="mb-0">
              <small>
                💡 <strong>Sugerencias:</strong><br />
                • Conecta una cámara web USB o usa un dispositivo con cámara integrada<br />
                • Verifica que ninguna otra aplicación esté usando la cámara<br />
                • Permite el acceso a la cámara en la configuración del navegador
              </small>
            </p>
          </Alert>
        ) : isLoading ? (
          <div className="py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Cargando cámara...</span>
            </div>
            <p className="mt-3">Cargando cámara...</p>
          </div>
        ) : (
          <>
            <video
              ref={videoRef}
              autoPlay
              playsInline
              className="w-100 rounded"
              style={{ maxHeight: "70vh" }}
            />
            <canvas ref={canvasRef} style={{ display: "none" }} />

            {documentType !== "selfie" && (
              <div
                className="camera-overlay"
                style={{
                  width: `${GUIDE_WIDTH}px`,
                  height: `${GUIDE_HEIGHT}px`,
                }}
              />
            )}
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button 
          variant="primary" 
          onClick={handleCapture}
          disabled={cameraError || isLoading}
        >
          Capturar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CameraCapture;
